import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

export default function SuartePlusCancellationDialog({ open, onClose, loading, onConfirm }) {
  return (
    <GenericPopup open={open} onBackgroundClick={onClose} opacity className="generic-popup_content profile-subscriptions__cancel-popup-card">
      <div className="profile-subscriptions__cancel-popup-header">
        <Text className="profile-subscriptions__cancel-popup-title ">Cancel subscription</Text>
        <XIcon className="profile-subscriptions__cancel-popup-close" onClick={onClose} />
      </div>
      <Text className="profile-subscriptions__cancel-popup-description ">
        Cancelling Suarte Plus will stop future auto-renewals but your account remains intact. You can re-subscribe anytime.
      </Text>
      <div className="profile-subscriptions__cancel-popup-actions">
        <ContinueButton loading={loading} onClick={onConfirm} className="profile-subscriptions__cancel-popup-confirm">
          Cancel Subscription
        </ContinueButton>
      </div>
    </GenericPopup>
  );
}
